"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWT_REAL_TIME = 'REAL_TIME';
exports.AWT_NEAR_REAL_TIME = 'NEAR_REAL_TIME';
exports.AWT_BEST_EFFORT = 'BEST_EFFORT';
